// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PortalModalContent_content__E1iJa {
  padding: 1rem;
  width: 56rem;
  max-width: 100%;
}
.PortalModalContent_content__E1iJa[data-narrow=true] {
  width: 40rem;
}`, "",{"version":3,"sources":["webpack://./src/components/PortalModal/PortalModalContent.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,eAAA;AACF;AACE;EACE,YAAA;AACJ","sourcesContent":[".content {\n  padding: 1rem;\n  width: 56rem;\n  max-width: 100%;\n}\n.content[data-narrow=true] {\n  width: 40rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `PortalModalContent_content__E1iJa`
};
export default ___CSS_LOADER_EXPORT___;
